import type { CrawlScheduleApi } from '@liks/backend-svc-api/esm/apis/CrawlScheduleApi';
import type { CrawlSchedule } from '@liks/backend-svc-api/esm/models/index';
import type {
  CrawlScheduleInput,
  CrawlScheduleUpdate,
  WithResourceId,
} from '../types/knowledge';
import { hasId } from './knowledgeServiceGuards';

export async function listCrawlSchedules(
  crawlScheduleApi: CrawlScheduleApi,
  databaseId: string,
): Promise<Array<WithResourceId<CrawlSchedule>>> {
  const schedules =
    await crawlScheduleApi.deLiksKnowledgebaseBoundaryCrawlScheduleResourceListCrawlSchedules(
      { knowledgeBaseId: databaseId },
    );
  return schedules.filter(hasId);
}

export async function createCrawlSchedule(
  crawlScheduleApi: CrawlScheduleApi,
  databaseId: string,
  input: CrawlScheduleInput,
): Promise<WithResourceId<CrawlSchedule>> {
  const schedule =
    await crawlScheduleApi.deLiksKnowledgebaseBoundaryCrawlScheduleResourceCreateCrawlSchedule(
      {
        knowledgeBaseId: databaseId,
        crawlSchedule: {
          crawlJobId: input.crawlJobId,
          scheduleInterval: input.scheduleInterval,
          customIntervalHours:
            input.scheduleInterval === 'CUSTOM'
              ? (input.customIntervalHours ?? undefined)
              : undefined,
          active: input.active ?? true,
        },
      },
    );

  if (!hasId(schedule)) {
    throw new Error('Backend returned a crawl schedule without id');
  }

  return schedule;
}

export async function updateCrawlSchedule(
  crawlScheduleApi: CrawlScheduleApi,
  databaseId: string,
  update: CrawlScheduleUpdate,
): Promise<WithResourceId<CrawlSchedule>> {
  const schedule =
    await crawlScheduleApi.deLiksKnowledgebaseBoundaryCrawlScheduleResourceUpdateCrawlSchedule(
      {
        knowledgeBaseId: databaseId,
        id: update.id,
        crawlSchedule: {
          id: update.id,
          crawlJobId: update.crawlJobId,
          knowledgeBaseId: databaseId,
          scheduleInterval: update.scheduleInterval,
          customIntervalHours:
            update.scheduleInterval === 'CUSTOM'
              ? (update.customIntervalHours ?? undefined)
              : undefined,
          active: update.active ?? true,
        },
      },
    );

  if (!hasId(schedule)) {
    throw new Error('Backend returned a crawl schedule without id');
  }

  return schedule;
}

export async function deleteCrawlSchedule(
  crawlScheduleApi: CrawlScheduleApi,
  databaseId: string,
  scheduleId: string,
): Promise<void> {
  await crawlScheduleApi.deLiksKnowledgebaseBoundaryCrawlScheduleResourceDeleteCrawlSchedule(
    { knowledgeBaseId: databaseId, id: scheduleId },
  );
}
